module.exports = __webpack_public_path__ + "static/media/apple_ipad_pro.aecfd1b7.jpg";